export interface AbastecimentosViewModel {
    flgEditavel: boolean;
    codAbastecimento: number;
    datAbastecimento: string;
    datDebito: string;
    datCredito: string;
    codFrota: number;
    papnreduz: string;
    codPosto: number;
    nomFantasiaPosto: string;
    codRede: number;
    dscPlaca: string;
    numProduto: number;
    qtdVolume: number;
    vlrUnitario: number;
    vlrUnitarioDesconto: number;
    vlrTotal: number;
    vlrTarifaCtf: number;
    indCombustivel: string;
    numKm: number;
    codStatus: number;
    pacCard: string;
    pacOnline: string;
    pa7Intern: string;
    dscTipoProduto: string;
    numChamado?: string;
    observacao?: string;
}

export interface  AbastecimentosViewModelEditado {
  guid: string,
  abastecimento: AbastecimentosViewModel
}


export interface IAbastecimentosViewModel {
    retorno: AbastecimentosViewModel[],
    sucesso: boolean,
    mensagens: string[]
}


export interface AbastecimentosEditadoViewModel {
  numeroChamado: string,
  salvoComSucesso: boolean
}

export interface IAbastecimentoEditadoResponse{
    retorno?: AbastecimentosEditadoViewModel,
    sucesso: boolean,
    mensagens: string[]
}


export interface ITransacoes{
  retorno?: Transacoes[],
  sucesso: boolean,
  mensagens: string[]
}

export interface Transacoes {
  PAX_SUBFRT: string;
    COD_FROTA?: number;  // Nullable, equivalente ao int? em C#
    PAP_NREDUZ: string;
    PAX_DESC: string;
    PAX_CODIGO: string;
    COD_TRANSACAO?: number;  // Nullable, equivalente ao long? em C#
    COD_ABASTECIMENTO?: number;  // Nullable
    DSC_PLACA: string;
    COD_VEICULO?: number;  // Nullable
    PB5_MODELO: string;
    DAT_ABASTECIMENTO?: Date;  // Nullable, equivalente ao DateTime? em C#
    COD_POSTO?: number;  // Nullable
    PA7_NREDUZ: string;
    DSC_APELIDO: string;
    NUM_KM?: number;  // Nullable
    NUM_DIST_PERCORRIDA?: number;  // Nullable
    ZE_DESCRIC: string;
    QTD_VOLUME?: number;  // Nullable, equivalente ao decimal? em C#
    VLR_TOTAL?: number;  // Nullable
    VLR_UNITARIO_DESCONTO?: number;  // Nullable
    KM_POR_LITRO?: number;  // Nullable
    KM_POR_VALOR?: number;  // Nullable
    DAT_DEBITO?: Date;  // Nullable
    POSX?: number;  // Nullable, equivalente ao double? em C#
    POSY?: number;  // Nullable
    DS_ENDERECO: string;
    NR_ENDERECO?: number;  // Nullable
    COD_ERRO?: number;
    DS_COMPLEMENTO: string;
    NM_BAIRRO: string;
    NM_CIDADE: string;
    CD_UF: string;
    CD_CEP: string;
    COD_MOTORISTA?: number;  // Nullable
    NUM_CPF: string;
    DSC_NOME: string;
    NUM_CELULAR: string;
    DSC_COMPLETA: string;
    SITUACAO: string;
    LIBERA_ABASTECIMENTO: string;
    COD_AUTORIZACAO?: number;  // Nullable
    DSC_TIPOPRODUTO: string;
    NR_LINHA?: number;  // Nullable
    DSC_COTA: string;
    COD_PRODUTO?: number;  // Nullable
    DSC_MENSAGEM_RETORNO: string
}

export interface InfoTransacaoModel{
  guid?: string;
  codAbastecimento?: string;
}

export interface InfoTransacaoModelResponse{
  retorno?: DadoTransacaoResponse,
  sucesso: boolean,
  mensagens: string[]
}

export interface DadoTransacaoResponse{
  imG_BASE64?: string
}